export enum FinHubPermissions {
  ACCESS_FINANCIAL_HUB = 'accessFinancialHub'
}
